export default __webpack_public_path__ + "static/media/students.e24684e5.jpg";